import React from 'react';
import styled, { css } from 'styled-components';

import { Spinner, Timestamp } from 'components/common';
import { Alert } from 'components/bootstrap';
import useAIQuotaStatus from 'ai/hooks/useAIQuotaStatus';

const StyledSpan = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
  `,
);

const AIQuotaInfo = ({ text = 'reports remaining today' }: { text?: string }) => {
  const { data, isLoading, isError } = useAIQuotaStatus();
  if (isLoading) return <Spinner />;

  if (!data || isError) return null;

  if (!data.limit || !data.used) return null;

  const quotaUsageInPercent = Math.round((data.used / data.limit) * 100);
  const isLimitExceeded = data?.remaining === 0;

  if (isLimitExceeded) {
    return (
      <Alert bsStyle="danger" title={`${quotaUsageInPercent}% of AI quota used`}>
        You have used <strong>{quotaUsageInPercent}%</strong> of your quota ({data.remaining}/{data.limit} remaining).
        {data.reset_at && (
          <>
            <br />
            Your quota will be reset on{' '}
            <strong>
              <Timestamp dateTime={data.reset_at} format="shortReadable" />
            </strong>
            .
          </>
        )}
      </Alert>
    );
  }

  return (
    <StyledSpan>
      <b>
        {data.remaining}/{data.limit}
      </b>{' '}
      {text}
    </StyledSpan>
  );
};

export default AIQuotaInfo;
